<template>
  <div class="relationship-tree">
    <div class="tree-box" v-for="bean in list" :key="bean.id" :class="{ 'has-child': bean.children.length, 'has-next': bean.hasNext }">
      <div class="top-box" :id="'id' + bean.id" :class="{ self: bean.isSelf == 1, noChild: bean.children.length == 0 }">
        <img
          v-if="bean.children.length && bean.hide"
          @click="changeHide(bean, false)"
          src="@static/images/my/relationship/tree-open.png"
          class="icon opne-icon"
        />
        <img
          v-if="bean.children.length && !bean.hide"
          @click="changeHide(bean, true)"
          src="@static/images/my/relationship/tree-close.png"
          class="icon opne-icon"
        />
        <div :class="bean.isSus == 1 ? 'orangeBg box' : bean.workingState == 0 ? 'redBg box' : 'greenBg box'">
          <div class="label">
            <span :class="bean.isSus == 1 ? 'orange dian' : bean.workingState == 0 ? 'red dian' : 'dian'"></span>
            <span class="name">{{ bean.name }}</span>
            <span class="staffNo">{{ bean.staffNo }}</span>
          </div>
          <div class="info">所属机构：{{ bean.orgName }}</div>
          <div class="info">所属团队：{{ bean.groupName }}</div>
          <div class="info">当前职级：{{ bean.rankName }}</div>
        </div>
      </div>
      <relationshipTree v-if="bean.children.length && !bean.hide" :list="bean.children"></relationshipTree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RelationshipTree',
  components: {},
  props: {
    list: null
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    changeHide(bean, isHide) {
      bean.hide = isHide;
      if (isHide) {
        this.dealTree(bean.children);
      } else if (bean.children && bean.children.length) {
        const last = bean.children[bean.children.length - 1];
        this.$nextTick(() => {
          document.querySelector('#id' + last.id).scrollIntoView();
        });
      }
    },
    dealTree(arr) {
      arr &&
        arr.forEach(item => {
          item.hide = true;
          this.dealTree(item.children);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './relationshipTree.scss';
</style>
